import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSpinnerComponent } from './custom-spinner/custom-spinner.component';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ImageSrcConverterDirective } from './image-src-converter/image-src-converter.directive';
import { ReportsHeaderComponent } from './reports-header/reports-header.component';

@NgModule({
  declarations: [CustomSpinnerComponent, DatePickerComponent, ImageSrcConverterDirective, ReportsHeaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxDaterangepickerMd
  ],
  exports: [
    CustomSpinnerComponent,
    DatePickerComponent,
    ImageSrcConverterDirective,
    ReportsHeaderComponent
  ]
})
export class PluginsModule { }
